import { useTrackEvent } from './analytics/useTrackEvent'
import { Input, Modal, Popover, Tooltip, Typography, message } from 'antd'
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'
import { getCustomerId, getLoId, getStatus, getCustomerEmail } from '../Common'
import { shouldRecordSmartlook } from 'utils'
import {
    CONTENT_TYPES,
    WHITE_LIST,
    GENERAL_GUIDELINES,
    IS_WHITE_LIST,
    getFirstPdfForProgram,
    PATH_CUSTOMER_ID,
    IS_IFRAMES,
    IFRAME_SESSION,
    IS_GUIDELINE_GPT,
} from './constants'
import { useAnonymousId } from './useAnonymousId'
import './WelcomeGuideline.css'
import { CustomMessage } from './AlertToast'
import InputHint from './components/InputHint'
import useScenarioUsed from './hooks/useScenarioUsed'
// import { useAllPrograms } from './hooks/useAllPrograms'
import smartlookClient from 'smartlook-client'
// import GuidelinesSelect from './components/ScenarioSearch/GuidelinesSelect'
import Mode from './components/Mode'
import RemainingCount from './components/RemainingCount'
import useTextareaPlaceholder from './hooks/useTextareaPlaceholder'
import GuidelineSelect from './components/GuidelineSelect'
import ICON_BOT from './assets/bot.svg'
import IframeLoginModal from './components/Widget/IframeLoginModal'
import WelcomeTitle from './components/Widget/WelcomeTitle'
import Voice from './components/Voice/'
import VoiceWaveform from './components/Voice/VoiceWaveform'
import GuidelineGptHeader from './components/Widget/GuidelinegptFunc'
import GetLenders from './components/GetLenders'
import AISwitch from 'StrataAl/Switch'

const { Text } = Typography
const { TextArea } = Input
const CLASSIC_DEPRECATION_NOTICE_KEY = 'classic_deprecation_notice_dismissed'

const LockIcon = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="10"
        height="14"
        viewBox="0 0 10 14"
        fill="none"
    >
        <path
            d="M4.33581 9.52853C4.33581 9.90263 4.63436 10.2059 5.0026 10.2059C5.37085 10.2059 5.6694 9.90263 5.6694 9.52853H4.33581ZM5.6694 8.26408C5.6694 7.88998 5.37085 7.5867 5.0026 7.5867C4.63436 7.5867 4.33581 7.88998 4.33581 8.26408H5.6694ZM6.81237 5.26463C6.81237 5.63872 7.11091 5.94201 7.47916 5.94201C7.84741 5.94201 8.14595 5.63872 8.14595 5.26463H6.81237ZM7.47916 3.33273L6.81237 3.32354V3.33273H7.47916ZM5.0026 0.677384L5.01274 8.1286e-05C5.00598 -2.70953e-05 4.99932 -2.70953e-05 4.99256 8.1286e-05L5.0026 0.677384ZM2.52609 3.33273H3.19295L3.19282 3.32354L2.52609 3.33273ZM1.8593 5.26463C1.8593 5.63872 2.15784 5.94201 2.52609 5.94201C2.89436 5.94201 3.19289 5.63872 3.19289 5.26463H1.8593ZM7.09749 5.82008C7.3995 6.03422 7.81513 5.95908 8.02593 5.65236C8.23672 5.34555 8.16275 4.9233 7.86083 4.70917L7.09749 5.82008ZM2.14445 4.70917C1.84248 4.9233 1.76855 5.34555 1.97932 5.65236C2.1901 5.95908 2.60577 6.03422 2.90775 5.82008L2.14445 4.70917ZM7.86083 4.70917C7.55908 4.4947 7.1439 4.56977 6.93283 4.8763C6.72168 5.18283 6.79574 5.60567 7.09749 5.82008L7.86083 4.70917ZM1.39922 6.43785L1.95367 6.81412L1.95447 6.81294L1.39922 6.43785ZM2.90828 5.81882C3.21004 5.6044 3.28357 5.18202 3.07249 4.87546C2.86141 4.56891 2.44622 4.49475 2.14445 4.70917L2.90828 5.81882ZM5.6694 9.52853V8.26408H4.33581V9.52853H5.6694ZM8.14595 5.26463V3.33273H6.81237V5.26463H8.14595ZM8.14586 3.34191C8.16996 1.53891 6.78365 0.0272579 5.01274 8.1286e-05L4.99256 1.35469C5.9963 1.37009 6.82686 2.23542 6.81237 3.32354L8.14586 3.34191ZM4.99256 8.1286e-05C3.2216 0.0272579 1.83531 1.53891 1.85936 3.34191L3.19282 3.32354C3.17831 2.23542 4.00891 1.37009 5.01274 1.35469L4.99256 8.1286e-05ZM1.8593 3.33273V5.26463H3.19289L3.19295 3.33273H1.8593ZM7.86083 4.70917C6.13713 3.48694 3.86808 3.48694 2.14445 4.70917L2.90775 5.82008C4.17285 4.92299 5.83236 4.92299 7.09749 5.82008L7.86083 4.70917ZM7.09749 5.82008C7.27468 5.94607 7.44066 6.08787 7.59429 6.24466L8.53945 5.28892C8.33043 5.07559 8.10292 4.88127 7.86083 4.70917L7.09749 5.82008ZM7.59429 6.24466C8.10319 6.7639 8.45312 7.43243 8.59608 8.16464L9.90424 7.90155C9.71078 6.91058 9.23638 5.99999 8.53945 5.28892L7.59429 6.24466ZM8.59608 8.16464C8.73771 8.89287 8.66445 9.64811 8.38671 10.3312L9.61921 10.8488C9.9975 9.91825 10.0967 8.8908 9.90424 7.90155L8.59608 8.16464ZM8.38671 10.3312C8.10532 11.0221 7.63412 11.6069 7.03552 12.0138L7.77717 13.1397C8.59812 12.5817 9.23842 11.7835 9.61921 10.8488L8.38671 10.3312ZM7.03552 12.0138C5.57818 13.005 3.65737 12.8141 2.40456 11.5468L1.46323 12.5064C3.16328 14.2262 5.788 14.4926 7.77717 13.1397L7.03552 12.0138ZM2.40456 11.5468C1.17166 10.2979 0.978273 8.29741 1.95367 6.81412L0.844773 6.06159C-0.481841 8.07893 -0.223944 10.7973 1.46323 12.5064L2.40456 11.5468ZM1.95447 6.81294C2.21072 6.42142 2.53445 6.08444 2.90828 5.81882L2.14445 4.70917C1.63283 5.07272 1.19158 5.5317 0.843973 6.06276L1.95447 6.81294Z"
            fill="#474849"
        />
    </svg>
)

const DocumentIcon = () => {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8.66706 2.44551C9.02313 2.15727 9.46735 2 9.92546 2H15.0294C15.5817 2 16.0294 2.44772 16.0294 3C16.0294 3.55228 15.5817 4 15.0294 4H12V7C12 8.10457 11.1046 9 10 9H5V18C5 18.5523 5.44771 19 6 19H17C17.5523 19 18 18.5523 18 18V11.3265C18 10.7742 18.4477 10.3265 19 10.3265C19.5523 10.3265 20 10.7742 20 11.3265V18C20 19.6569 18.6569 21 17 21H6C4.34315 21 3 19.6569 3 18V7.98728C3 7.38376 3.27252 6.81252 3.7416 6.43279L8.66706 2.44551ZM6.21958 7H10V4L9.92546 4L6.21958 7ZM7 12C7 11.4477 7.44772 11 8 11H15C15.5523 11 16 11.4477 16 12C16 12.5523 15.5523 13 15 13H8C7.44772 13 7 12.5523 7 12ZM7 15C7 14.4477 7.44772 14 8 14H13C13.5523 14 14 14.4477 14 15C14 15.5523 13.5523 16 13 16H8C7.44772 16 7 15.5523 7 15Z"
                fill="#474849"
            />
            <path
                d="M18 14.0009L18 5.00094C18 4.44866 17.5523 4.00095 17 4.00095L10 4.00095L10 2.00095L17 2.00095C18.6569 2.00095 20 3.34409 20 5.00095L20 15.0009L18 14.0009Z"
                fill="#474849"
            />
        </svg>
    )
}

const SendIcon = ({ active }) => (
    <img
        src={
            active
                ? '/images/send-icon-active.svg'
                : '/images/send-icon-inactive.svg'
        }
        alt={active ? 'Send icon active' : 'Send icon inactive'}
        // width="26"
        // height="26"
        className={`send-icon ${active ? 'active' : 'inactive'}`}
    />
)

const StarIcon = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
    >
        <g clipPath="url(#clip0_2922_2185)">
            <path
                d="M3.02183 1.59961V4.44405M1.59961 3.02183H4.44405M3.73294 11.5552V14.3996M2.31072 12.9774H5.15517M8.71072 1.59961L10.3361 6.4758L14.3996 7.99961L10.3361 9.52342L8.71072 14.3996L7.08532 9.52342L3.02183 7.99961L7.08532 6.4758L8.71072 1.59961Z"
                stroke="url(#paint0_linear_2922_2185)"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </g>
        <defs>
            <linearGradient
                id="paint0_linear_2922_2185"
                x1="1.59961"
                y1="7.99961"
                x2="14.4074"
                y2="7.99961"
                gradientUnits="userSpaceOnUse"
            >
                <stop offset="0.245186" stopColor="#7E37F6" />
                <stop offset="1" stopColor="#23B6F1" />
            </linearGradient>
            <clipPath id="clip0_2922_2185">
                <rect width="16" height="16" fill="white" />
            </clipPath>
        </defs>
    </svg>
)

const CloseIcon = () => (
    <svg
        width="12"
        height="12"
        viewBox="0 0 12 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M11 1L1 11M1 1L11 11"
            stroke="#8C8C8C"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

function WelcomeGuideline({
    isPaid,
    isReceivingAnswer,
    showHistory,
    iframeConfig,
    setShowHistory,
    isMobile,
    fromLanding,
    onSendMessage,
    programs,
    contact,
    anomaly,
    onPreviewGuideline,
    activeIframeSession,
    setShowIframeLoginModal,
    companyPayMode,
    setShowSelfPayUpgradeModal,
    profile,
    setSignType,
    setTriggerType,
    currentBillingStatus,
    promoCodeValidity,
    setApplyPromoCode,
    onAIChange
}) {
    const dispatch = useDispatch()
    const { trackLimitAlertUpgradeClicked, trackStandalonePageView, trackQuestionAsk, trackDailyLimitReached, trackLimitDemoClick, trackStandaloneDemoClick, trackStandaloneSigninClick, trackStandaloneActive, trackStandaloneSignupClick } = useTrackEvent()

    useEffect(() => {
        if (anomaly?.DATABASE_ERROR) setShowHistory(false);
    }, [anomaly]);

    const subscriptionReducer = useSelector(
        (state) => state.subscriptionReducer?.currentInfo
    )

    useEffect(() => {
        if (sessionStorage.getItem(CLASSIC_DEPRECATION_NOTICE_KEY)) {
            return
        }

        const modal = Modal.info({
            icon: null,
            title: 'Classic version will be deprecated on June 30',
            content: (
                <div>
                    For questions or assistance, please contact:{' '}
                    <a href="mailto:support@zeitro.com">support@zeitro.com</a>
                </div>
            ),
            okText: 'Got it',
            centered: true,
            width: 600,
            onOk: () => {
                sessionStorage.setItem(CLASSIC_DEPRECATION_NOTICE_KEY, 'true')
            },
        })

        return () => {
            modal.destroy()
        }
    }, [])

    // Get anonymous ID for anonymous users
    const anonymousId = useAnonymousId()

    const SERVER_ERROR = anomaly?.MODEL_ERROR || anomaly?.DATABASE_ERROR; // 数据库、模型错误，都会导致无法继续查询

    // Fetch all programs from database
    // const { programs: dbPrograms, loading: programsLoading, error: programsError } = useAllPrograms()

    // const isBetaUser = useMemo(() => {
    //     const loId = getLoId()
    //     const customerId = getCustomerId()

    //     // Scenario desk is only available for GMCC paid users
    //     if (customerId === 'gmcc') {
    //         const status = getStatus(loId, subscriptionReducer.loanOfficers)
    //         return status !== 'free'
    //     }

    //     return (
    //         customerId === 'zeitro' ||
    //         loId === 'b951cb04-addd-4b5a-b124-25c90fe34ba7' || // london.story@gmail.com in zzzz
    //         loId === '7d75fedc-4243-4fd7-882b-60bef2626a20' // london.story@gmail.com in org1
    //     )
    // }, [subscriptionReducer.loanOfficers])


    // const initialMode = useMemo(() => {
    //     const cachedMode = localStorage.getItem('activeGPTmode')

    //     // if cached mode is not set or user is not a beta user, default to 'guideline'
    //     if (!cachedMode || !isBetaUser) {
    //         return 'guideline'
    //     }

    //     // otherwise, use the cached mode
    //     return cachedMode
    // }, [isBetaUser])

    const [activeTab, setActiveTab] = useState(() => {
        const savedMode = sessionStorage.getItem('activeGPTmode')
        if (savedMode === 'guideline' || savedMode === 'scenario') {
            return savedMode
        }
        return PATH_CUSTOMER_ID === 'successlending' || getCustomerId() === 'successlending' ? 'guideline' : 'scenario'
    })
    const [activeSection, setActiveSection] = useState('general')
    const [inputValue, setInputValue] = useState('')
    const [selectedGuidelines, setSelectedGuidelines] = useState([])
    const [shareModalVisible, setShareModalVisible] = useState(false)

    // const [model, setModel] = useState(
    //     sessionStorage.getItem("scenario_model") || "instant",  // instant deepthinking
    // );

    // 语音录音状态和音频数据
    const [isRecording, setIsRecording] = useState(false)
    const [isVoiceUploading, setIsVoiceUploading] = useState(false)
    const [audioData, setAudioData] = useState(null)

    const textareaRef = useRef(null)
    // Voice 组件引用，用于停止录音
    const voiceRef = useRef(null)

    // 路由变化监听：当路由变化时自动停止录音
    const location = useLocation()
    const prevPathnameRef = useRef(location.pathname)
    useEffect(() => {
        // 检查路径是否真的发生了变化（排除首次渲染）
        if (prevPathnameRef.current !== location.pathname) {
            prevPathnameRef.current = location.pathname
            // 如果正在录音或上传中，停止录音并重置状态
            if (isRecording || isVoiceUploading) {
                if (voiceRef.current?.stopRecording) {
                    voiceRef.current.stopRecording()
                }
                setIsRecording(false)
                setIsVoiceUploading(false)
                setAudioData(null)
            }
        }
    }, [location.pathname, isRecording, isVoiceUploading])

    const placeholder = useTextareaPlaceholder();

    // 处理音频数据回调（用于声波可视化）
    const handleAudioData = useCallback((data) => {
        // 创建新的 Uint8Array 副本，避免共享引用问题
        setAudioData(new Uint8Array(data))
    }, [])

    // 处理录音状态变化回调
    const handleRecordingChange = useCallback((recording) => {
        setIsRecording(recording)
        if (!recording) {
            // 录音结束时清空音频数据
            setAudioData(null)
        }
    }, [])

    // 处理 Voice 组件状态变化（用于显示上传 loading）
    const handleVoiceStatusChange = useCallback((status) => {
        // status: 'idle' | 'recording' | 'uploading'
        setIsVoiceUploading(status === 'uploading')
    }, [])

    // 停止录音
    const handleStopRecording = useCallback(() => {
        if (voiceRef.current?.stopRecording) {
            setIsRecording(false);
            voiceRef.current.stopRecording()
        }
    }, [])

    // 处理语音转文字结果，将文本追加到输入框（增量更新）
    // 注意：textarea 高度调整由 useEffect 自动处理（监听 inputValue 变化）
    const handleVoiceTranscribed = useCallback((text) => {
        if (text && typeof text === 'string') {
            setInputValue((prev) => {
                // 如果已有内容，在末尾追加空格和新文本；否则直接使用新文本
                if (prev && prev.trim()) {
                    return prev.trim() + ' ' + text
                }
                return text
            })
        }
    }, [])

    // function onModelChange(value) {
    //     sessionStorage.setItem('scenario_model', value);
    //     setModel(value)

    //     // Dispatch custom event to notify Chat component about mode change
    //     window.dispatchEvent(new CustomEvent('scenarioModelChange', {
    //         detail: { newMode: value }
    //     }))
    // }

    useEffect(() => {
        if (!IS_IFRAMES && shouldRecordSmartlook()) {
            const loId = getLoId()
            smartlookClient.init('702c7d241073da6ad788698d48d75342c29fa91b');
            smartlookClient.record({
                emails: true,
                forms: true,
                numbers: true,
                ips: true,
            })
            smartlookClient.identify(loId, {
                email: getCustomerEmail(),
            })
        }
    }, [IS_IFRAMES]);

    // Track standalone page view for fromLanding users (Statsig tracking)
    useEffect(() => {
        if (fromLanding && anonymousId) {
            trackStandalonePageView(anonymousId)
        }
    }, [fromLanding, anonymousId, trackStandalonePageView])


    const lastUsedGuideline = sessionStorage.getItem('lastUsedGuideline')
    const sortedGuidelines = useMemo(() => {
        if (!lastUsedGuideline) return GENERAL_GUIDELINES

        return GENERAL_GUIDELINES.sort((a, b) => {
            if (a.id === lastUsedGuideline) return -1
            if (b.id === lastUsedGuideline) return 1
            return 0
        })
    }, [lastUsedGuideline])

    useEffect(() => {
        sessionStorage.setItem('activeGPTmode', activeTab)
    }, [activeTab])

    // Force scenario tab for greenbox customers
    useEffect(() => {
        if (PATH_CUSTOMER_ID === 'greenbox') {
            setActiveTab('scenario')
            sessionStorage.setItem('activeGPTmode', 'scenario')
        }
        if (PATH_CUSTOMER_ID === 'flipsidelendingllc' || getCustomerId() === 'flipsidelendingllc') {
            setActiveTab('scenario')
            sessionStorage.setItem('activeGPTmode', 'scenario')
        }
        if (PATH_CUSTOMER_ID === 'iservelending' || getCustomerId() === 'iservelending') {
            setActiveTab('guideline')
            sessionStorage.setItem('activeGPTmode', 'guideline')
        }
        if (PATH_CUSTOMER_ID === 'homesteadfundingcorp' || getCustomerId() === 'homesteadfundingcorp') {
            setActiveTab('guideline')
            sessionStorage.setItem('activeGPTmode', 'guideline')
        }
    }, [])

    const handleTabClick = (tab) => {
        // if (tab === 'scenario' && !isBetaUser) {
        //     setIsModalVisible(true)
        //     return
        // }
        setActiveTab(tab)
        sessionStorage.setItem('activeGPTmode', tab)
    }

    const handleGuidelineClick = useCallback(
        (item) => {
            // iframe模式下，选择进入某个agency guidelines时,
            // 需要先验证iframe session是否存在，不存在则弹出iframe登录modal
            if (IS_IFRAMES && !activeIframeSession) {
                setShowIframeLoginModal(true);
                return;
            }
            sessionStorage.setItem('lastUsedGuideline', item.id)
            dispatch({ type: 'SHOW_PDF', data: false })
            dispatch({ type: 'CHANGE_PDF', data: item.id })
            setShowHistory(false)
        },
        [dispatch, setShowHistory, setShowIframeLoginModal, activeIframeSession, IS_IFRAMES]
    )

    const handleDemoClick = () => {
        // Track the click event for standalone page header "Book a demo" button
        if (fromLanding && anonymousId) {
            trackStandaloneDemoClick(anonymousId)
        }
        window.open('https://www.zeitro.com/demo', '_blank')
    }

    const handleShareClick = () => {
        setShareModalVisible(true)
    }

    const handleIframeSigninClick = () => {
        setShowIframeLoginModal(true)
    }

    const handleCopyLink = async () => {
        try {
            await navigator.clipboard.writeText('https://www.zeitro.com/scenario-ai')
            CustomMessage.success('Link copied to clipboard!')
        } catch (err) {
            CustomMessage.error('Failed to copy link')
        }
    }

    const handleInputChange = useCallback((e) => {
        setInputValue(e.target.value)
        adjustTextareaHeight()
    }, [])

    // Adjust textarea height and control scrollbar visibility
    const adjustTextareaHeight = useCallback(() => {
        if (!textareaRef.current) return

        // Get the actual textarea DOM element from Ant Design TextArea
        const textareaElement = textareaRef.current.resizableTextArea?.textArea
        if (!textareaElement) return

        // Reset height to get natural height
        textareaElement.style.height = 'auto'
        const scrollHeight = textareaElement.scrollHeight

        // Use different max heights based on screen size
        const maxHeight = isMobile ? 120 : 132

        // When content exceeds max height, add scrollable class
        if (scrollHeight <= maxHeight) {
            textareaElement.style.height = `${scrollHeight}px`
            textareaElement.classList.remove('scrollable')
        } else {
            textareaElement.style.height = `${maxHeight}px`
            textareaElement.classList.add('scrollable')
        }
    }, [isMobile])

    // Adjust textarea height when input value changes
    useEffect(() => {
        adjustTextareaHeight()
    }, [inputValue, adjustTextareaHeight])

    // Check if send button should be active
    const isSendButtonActive = useMemo(() => {
        return inputValue.trim().length > 0
    }, [inputValue])

    const SCENARIO_AI_USE = useScenarioUsed();

    const handleSend = useCallback(async () => {
        // 如果未登陆，而且提问过一次，再次提问就必须先登陆
        if(SCENARIO_AI_USE.REMAINING < 3 && !sessionStorage.getItem('ZeitroA') && IS_GUIDELINE_GPT) {
            return setSignType('SIGNIN');
        }
        if (SERVER_ERROR || anomaly?.MODEL_ERROR || anomaly?.DATABASE_ERROR) return;
        if (!IS_IFRAMES && !SCENARIO_AI_USE.PAID && SCENARIO_AI_USE.DISABLED) return;
        if (IS_IFRAMES && profile?.AccountTier !== 'paid' && SCENARIO_AI_USE.DISABLED) return;
        const value = inputValue || placeholder;
        // 若未输入，可直接使用 "placeholder" 提问
        const isSendButtonActive = value.trim().length > 0;
        if (isSendButtonActive && !isReceivingAnswer) {
            // Track question_ask event for standalone page (fromLanding = true)
            if (fromLanding) {
                trackQuestionAsk()
                // Track standalone active event for retention analysis (D1/D3/D5/D7)
                trackStandaloneActive()
            }

            dispatch({ type: 'SHOW_PDF', data: false })

            // Use appropriate content type based on customer
            const contentType = CONTENT_TYPES.SCENARIO_DESK
            dispatch({ type: 'CHANGE_PDF', data: contentType })

            let itemNames = []
            let programIds = []

            const { GUIDELINES, MAP_GUIDELINE_ID } = programs.data
            if (selectedGuidelines.length === 0) {
                programIds = GUIDELINES.map((program) => program.id)
            } else {
                programIds = selectedGuidelines.filter(k => MAP_GUIDELINE_ID[k])
            }
            itemNames = selectedGuidelines.length === 0
                ? GUIDELINES.map((v) => v.programName)
                : selectedGuidelines.map(k => MAP_GUIDELINE_ID[k]?.programName).filter(Boolean)

            // Auto-display first available PDF from selected programs/lenders
            if (itemNames.length > 0) {
                // Find the first selected program/lender that has a PDF mapping using centralized function
                let firstPdfFileName = null
                for (const itemName of itemNames) {
                    const pdfFileName = await getFirstPdfForProgram(itemName)
                    if (pdfFileName) {
                        firstPdfFileName = pdfFileName
                        break
                    }
                }
                // If we found a PDF to display, emit it through the jumpToPage mechanism
                if (firstPdfFileName && onSendMessage) {
                    // Store the PDF info to be processed when the message is sent
                    const dynamicPdfInfo = {
                        dynamicLoad: true,
                        pdfFileName: firstPdfFileName
                    }
                    // Add the PDF info to the onSendMessage call so it can be handled in Chat.js
                    setTimeout(() => {
                        // For Scenario Desk, send program_ids;
                        onSendMessage(value.trim(), contentType, programIds, dynamicPdfInfo)
                    }, 0)
                } else {
                    // No matching PDF found, send message normally
                    if (onSendMessage) {
                        onSendMessage(value.trim(), contentType, programIds)
                    }
                }
            } else {
                // No items selected, send message normally
                if (onSendMessage) {
                    onSendMessage(value.trim(), contentType, programIds)
                }
            }

            // Save selected program IDs to Redux before sending (for PDFViewer dropdown)
            dispatch({ type: 'SCENARIO_SOURCE', data: programIds })

            // Debug logging for Scenario Desk
            // if (!isGMCCMode) {
            //     console.log('Scenario Desk - Selected programs (raw names):', selectedGuidelines)
            //     console.log('Scenario Desk - Selected programs (display names):', selectedGuidelines.map(name => {
            //         const program = SCENARIO_PROGRAMS.find(p => p.id === name)
            //         return program ? program.name : name
            //     }))
            //     console.log('Scenario Desk - Program IDs to send:', programIds)
            //     console.log('Scenario Desk - Database programs:', dbPrograms)
            // }

            setShowHistory(false)

            // Clear input and reset textarea height
            setInputValue('')
            setTimeout(() => {
                // Reset textarea
                if (textareaRef.current?.resizableTextArea?.textArea) {
                    const textareaElement =
                        textareaRef.current.resizableTextArea.textArea
                    textareaElement.style.height = 'auto'
                    textareaElement.classList.remove('scrollable')
                }
            }, 0)
        }
    }, [
        isSendButtonActive,
        isReceivingAnswer,
        onSendMessage,
        inputValue,
        selectedGuidelines,
        dispatch,
        setShowHistory,
        programs,
        placeholder,
        SERVER_ERROR,
        anomaly,
        fromLanding,
        anonymousId,
        trackQuestionAsk
    ])

    const verifyAndSendQuery = useCallback(() => {
        if (activeIframeSession) {
            handleSend();
        } else {
            setShowIframeLoginModal(true);
        }
    }, [activeIframeSession, setShowIframeLoginModal, handleSend]);

    const handleClickSend = useCallback(() => {
        if (IS_IFRAMES) {
            verifyAndSendQuery();
        } else {
            handleSend();
        }
    }, [IS_IFRAMES, verifyAndSendQuery, handleSend]);

    // Check for query parameter and populate input field
    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search)
        const queryParam = urlParams.get('query')

        if (queryParam && queryParam.trim()) {
            setInputValue(queryParam)

            setTimeout(() => {
                if (textareaRef.current) {
                    // For Ant Design TextArea, we need to access the native textarea element
                    const nativeTextarea = textareaRef.current.resizableTextArea?.textArea || textareaRef.current
                    if (nativeTextarea) {
                        nativeTextarea.focus()
                        // Move cursor to the end of the text
                        const textLength = queryParam.length
                        nativeTextarea.setSelectionRange(textLength, textLength)
                    }
                }
            }, 100)

            // Clear only the 'query' parameter, keep other params (utm_campaign, utm_source, etc.)
            urlParams.delete('query')
            const remainingParams = urlParams.toString()
            const newUrl = window.location.pathname + (remainingParams ? '?' + remainingParams : '') + window.location.hash
            window.history.replaceState({}, document.title, newUrl)
        }
    }, [])

    const handleKeyPress = useCallback(
        (e) => {
            if (e.key === 'Enter' && !e.shiftKey) {
                e.preventDefault()
                handleClickSend()
            }
        },
        [handleClickSend]
    )

    function onSkip() {
        window.open("https://www.zeitro.com/demo", "_blank");
    }

    // Handle "Go Unlimited" click after hitting limit (for standalone page tracking)
    const handleLimitDemoClick = useCallback(() => {
        // Track the click event for standalone page
        if (fromLanding) {
            trackLimitDemoClick()
        }
        // Open demo page
        window.open("https://www.zeitro.com/demo", "_blank");
    }, [fromLanding, trackLimitDemoClick])

    const renderGuidelineItems = (guidelines) => {
        const rows = []
        const itemsPerRow = isMobile ? 1 : 3

        for (let i = 0; i < guidelines.length; i += itemsPerRow) {
            const rowItems = guidelines.slice(
                i,
                Math.min(i + itemsPerRow, guidelines.length)
            )
            rows.push(
                <div key={i} className="guideline-row">
                    {rowItems.map((item) => (
                        <div
                            key={item.id}
                            className="guideline-item"
                            onClick={() => handleGuidelineClick(item)}
                        >
                            <DocumentIcon />
                            <span className="guideline-item-text">
                                {item.value}
                            </span>
                            {lastUsedGuideline === item.id && (
                                <span className="last-used-badge">
                                    Last used
                                </span>
                            )}
                        </div>
                    ))}
                    {/* Fill empty slots with invisible items to maintain layout */}
                    {!isMobile &&
                        Array(itemsPerRow - rowItems.length)
                            .fill()
                            .map((_, index) => (
                                <div
                                    key={`empty-${index}`}
                                    className="guideline-item"
                                    style={{ visibility: 'hidden' }}
                                />
                            ))}
                </div>
            )
        }
        return rows
    }

    // 未选择任何 “guidelines” 时，实际上会全选所有的 "programs"
    // const GUIDELINE_COUNT = useMemo(() => (
    //     selectedGuidelines?.length ? selectedGuidelines?.length : programs.data.GUIDELINES?.length
    // ), [selectedGuidelines, programs]);

    // 白名单不限制次数
    const IS_DISABLED = useMemo(
        () => IS_WHITE_LIST ? false : (!IS_IFRAMES ? !SCENARIO_AI_USE.PAID && SCENARIO_AI_USE.DISABLED : SCENARIO_AI_USE.DISABLED),
        [SCENARIO_AI_USE.DISABLED, SCENARIO_AI_USE.PAID, IS_IFRAMES],
    );
    // Track daily limit reached event for standalone page (fromLanding = true)
    // Use a ref to track if we've already fired the event to prevent duplicate events
    const hasTrackedLimitReached = useRef(false)
    useEffect(() => {
        if (fromLanding && IS_DISABLED && !hasTrackedLimitReached.current) {
            trackDailyLimitReached()
            hasTrackedLimitReached.current = true
        }
    }, [fromLanding, IS_DISABLED, trackDailyLimitReached])

    const handleUpgrade = useCallback(() => {
        // Track limit alert upgrade clicked
        const currentUsage = SCENARIO_AI_USE.COUNT;
        trackLimitAlertUpgradeClicked(profile, currentUsage, currentBillingStatus);
        
        setTriggerType('usage-limit-reached-alert');
        if (PATH_CUSTOMER_ID === 'successlending' && currentBillingStatus === 'inactive' && promoCodeValidity === 'valid') {
            setApplyPromoCode(true);
        }
        setShowSelfPayUpgradeModal(true);
    }, [setShowSelfPayUpgradeModal, setTriggerType, setApplyPromoCode, currentBillingStatus, promoCodeValidity, trackLimitAlertUpgradeClicked, profile, SCENARIO_AI_USE]);

    return (
        <div className={(IS_IFRAMES || IS_GUIDELINE_GPT) ? 'welcome-guideline-page-iframe' : 'welcome-guideline-page'}>
            {!(IS_IFRAMES || IS_GUIDELINE_GPT) && (
                <div className="guideline-title-header">
                    {
                        // public guidelint gpt 页面显示zeitro logo， iframe 或 los内guideline gpt页面显示mortgage ai 图标
                        fromLanding ? (
                            <a
                                href="https://www.zeitro.com"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="zeitro-logo-link"
                            >
                                <img
                                    src="/images/zeitro-logo.svg"
                                    alt="Zeitro Logo"
                                    className="zeitro-logo"
                                />
                            </a>
                        ) : (
                            <div
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '4px',
                                }}
                            >
                                <img
                                    style={{
                                        width: '24px',
                                        height: '24px',
                                    }}
                                    src={ICON_BOT}
                                    alt="Bot Avatar"
                                    className="avatar"
                                />
                                <Text className="welcome-guideline-title">
                                    MortgageAI
                                </Text>
                                <AISwitch value="CLASSIC" onChange={onAIChange} />
                            </div>
                        )
                    }
                    <div className="guideline-title-header-right">
                        {
                            !fromLanding && (
                                <div
                                    className="guideline-share-btn"
                                    onClick={handleShareClick}
                                >
                                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                                        <path d="M9.75014 3V6C4.81889 6.771 2.98514 11.091 2.25014 15C2.22239 15.1545 6.28814 10.5285 9.75014 10.5V13.5L15.7501 8.25L9.75014 3Z" stroke="#325CEB" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                    <span>Share</span>
                                </div>
                            )
                        }
                        {/* {PATH_CUSTOMER_ID !== 'greenbox' && (
                            <Tooltip title='Book a demo for fully customized Scenario AI'>
                                <div
                                    className="guideline-demo-btn"
                                    onClick={handleDemoClick}
                                >
                                    Book a demo
                                </div>
                            </Tooltip>
                        )} */}
                        {/* {
                            fromLanding && !IS_IFRAMES && (
                               sessionStorage.getItem('ZeitroA') ?
                               null
                              : <>
                                    <button
                                        className="floating-bar-btn guideline-signin-btn"
                                        onClick={() => {
                                            // Track the click event for standalone page "Sign In" button
                                            if (anonymousId) {
                                                trackStandaloneSigninClick(anonymousId)
                                            }
                                            setSignType('SIGNIN');

                                        }}
                                    >
                                        Sign In
                                    </button>

                                    <button
                                        className="floating-bar-btn guideline-signup-btn"
                                        onClick={() => {
                                            // Track the click event for standalone page "Sign In" button
                                            if (anonymousId) {
                                                trackStandaloneSignupClick(anonymousId)
                                            }
                                            setSignType('SIGNUP');
                                        }}
                                    >
                                        Sign Up
                                    </button>
                                </>
                            )
                        } */}
                        {!showHistory && !fromLanding && !anomaly?.DATABASE_ERROR && (
                            <div className="welcome-guideline-header">
                                <div
                                    className="guideline-history-btn"
                                    onClick={() => {
                                        setShowHistory(!showHistory)
                                    }}
                                >
                                    {
                                        isMobile ? (
                                            <img
                                                style={{
                                                    width: '40px',
                                                    height: '40px',
                                                }}
                                                src='/images/history.svg'
                                            />
                                        ) : (
                                            <div className="guideline-history-menu-btn">
                                                <img
                                                    src='/images/guideline-history-menu.svg'
                                                />
                                            </div>
                                        )
                                    }
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            )}

            {IS_IFRAMES && !activeIframeSession && <WelcomeTitle isMobile={isMobile} />}

            <div className="welcome-guideline-content">
                <GetLenders isMobile={isMobile} />
                {/* Toggle Text Container */}
                {getCustomerId() !== "greenbox" && getCustomerId() !== "iservelending" && getCustomerId() !== 'flipsidelendingllc' && getCustomerId() !== 'homesteadfundingcorp' && !iframeConfig?.hideModeToggle && <div className="toggle-mode-wrapper" style={IS_IFRAMES ? (isMobile ? undefined : {paddingBottom: '40px'}) : undefined}>
                    <div className="guideline-toggle">
                        {<div
                            className={`guideline-toggle-item ${activeTab === 'guideline' ? 'active' : ''
                                }`}
                            onClick={() => handleTabClick('guideline')}
                        >
                            <span className="guideline-toggle-text">
                                Agency guidelines
                            </span>
                        </div>}
                        <div
                            className={`guideline-toggle-item ${activeTab === 'scenario' ? 'active' : ''
                                }`}
                            onClick={() => {
                                handleTabClick('scenario')
                            }}
                        >
                            <span className="guideline-toggle-text scenario-toggle-text">
                                Scenario AI
                            </span>
                        </div>
                    </div>

                    {activeTab === 'guideline' ? (
                        <Text className="welcome-guideline-subtitle">
                            Select a guideline to get started
                        </Text>
                    ) : (
                        !IS_IFRAMES && (
                            <Text
                                className="welcome-guideline-subtitle"
                                style={IS_DISABLED ? { margin: '5px 0px 45px' } : undefined}
                            >
                                Get instant clarity on selected guidelines.
                            </Text>
                        )
                    )}
                </div>}

                {/* Guidelines Container */}
                {activeTab === 'guideline' ? (
                    <div className="guideline-sections-container">
                        <div className="guideline-section-tabs">
                            <div
                                className={`guideline-section-tab ${activeSection === 'general' ? 'active' : ''
                                    }`}
                                onClick={() => setActiveSection('general')}
                            >
                                {`General Guidelines (${sortedGuidelines.length})`}
                            </div>
                        </div>
                        <div className="guideline-wrapper">
                            {renderGuidelineItems(
                                activeSection === 'lender'
                                    ? []
                                    : sortedGuidelines
                            )}
                        </div>
                    </div>
                ) : (
                    <>
                        <div className="scenario-desk-container">
                            <div className="scenario-search-input-wrapper filter-open">
                                {!isMobile && (
                                    <div className="scenario-search-input">
                                        <div className="scenario-chat-wrapper">
                                            {(isPaid || (IS_IFRAMES && activeIframeSession)) && <Voice
                                                ref={voiceRef}
                                                onAudioData={handleAudioData}
                                                onRecordingChange={handleRecordingChange}
                                                onTranscribed={handleVoiceTranscribed}
                                                onStatusChange={handleVoiceStatusChange}
                                            />}
                                            <InputHint top={-51}
                                                type='error'
                                                onClick={onSkip}
                                                buttonText='Contact us'
                                                show={anomaly?.MODEL_ERROR}
                                                text='System is experiencing temporary disruption - will be back shortly!'
                                            />
                                            <InputHint
                                                top={-51}
                                                onClick={handleLimitDemoClick}
                                                buttonText='Go unlimited'
                                                show={IS_DISABLED && !IS_IFRAMES}
                                            />
                                            <InputHint
                                                top={-51}
                                                buttonText='Upgrade'
                                                onClick={handleUpgrade}
                                                show={IS_DISABLED && IS_IFRAMES && profile?.AccountTier !== 'paid' && activeIframeSession}
                                            />
                                            <div className='scenario-chat-textarea-layout'>
                                                {(isRecording || isVoiceUploading) ? (
                                                    // 录音中或上传中显示声波可视化
                                                    <VoiceWaveform
                                                        audioData={audioData}
                                                        onStop={handleStopRecording}
                                                        barCount={60}
                                                        isLoading={isVoiceUploading}
                                                    />
                                                ) : (
                                                    <TextArea
                                                        ref={textareaRef}
                                                        value={inputValue}
                                                        placeholder={placeholder}
                                                        onKeyPress={handleKeyPress}
                                                        onChange={handleInputChange}
                                                        className="scenario-chat-textarea"
                                                        disabled={SERVER_ERROR || (!IS_IFRAMES && !SCENARIO_AI_USE.PAID && IS_DISABLED) || (IS_IFRAMES && SCENARIO_AI_USE.PAID && profile?.AccountTier !== 'paid' && IS_DISABLED)}
                                                        autoSize={{ minRows: 2, maxRows: 6 }}
                                                    />
                                                )}
                                            </div>
                                            {!isRecording && (
                                                <div className='scenario-chat-tools'>
                                                    <Mode />
                                                    {!IS_IFRAMES && !SCENARIO_AI_USE.PAID && <RemainingCount count={SCENARIO_AI_USE.REMAINING} top={13} />}
                                                    {IS_IFRAMES && profile?.AccountTier !== 'paid' && activeIframeSession && <RemainingCount count={SCENARIO_AI_USE.REMAINING} top={13} />}
                                                </div>
                                            )}
                                            {!isRecording && !isVoiceUploading && (
                                                <div
                                                    className={`scenario-send-button ${isSendButtonActive
                                                        ? 'active'
                                                        :
                                                        activeIframeSession ? 'active' : ''
                                                        }`}
                                                    onClick={() => handleClickSend()}
                                                >
                                                    <SendIcon
                                                        active={isSendButtonActive || activeIframeSession}
                                                    />
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                )}
                                <GuidelineSelect
                                    contact={contact}
                                    programs={programs}
                                    isMobile={isMobile}
                                    onPreview={onPreviewGuideline}
                                    onChange={setSelectedGuidelines}
                                    disabled={anomaly?.DATABASE_ERROR}
                                />
                            </div>
                        </div>
                        {iframeConfig ? <footer className='iframe-powered-by'>
                            <a href="https://www.zeitro.com" target="_blank">
                                Powered by
                                <img
                                    src="/images/zeitro-logo.svg"
                                    alt="Zeitro Logo"
                                    className="zeitro-logo"
                                />
                            </a>
                        </footer> : null}
                    </>
                )}
            </div>

            {/* Mobile input at bottom */}
            {isMobile && activeTab === 'scenario' && (
                <div className="mobile-input-container">
                    <div className="mobile-search-input">
                        <div className="mobile-chat-wrapper">
                            {(isPaid || (IS_IFRAMES && activeIframeSession)) && <Voice
                                ref={voiceRef}
                                onAudioData={handleAudioData}
                                onRecordingChange={handleRecordingChange}
                                onTranscribed={handleVoiceTranscribed}
                                onStatusChange={handleVoiceStatusChange}
                            />}
                            <InputHint
                                top={-47}
                                type='error'
                                onClick={onSkip}
                                buttonText='Contact us'
                                show={anomaly?.MODEL_ERROR}
                                text='System is experiencing temporary disruption - will be back shortly!'
                            />
                            <InputHint
                                top={-47}
                                onClick={handleLimitDemoClick}
                                buttonText='Book a demo'
                                show={SCENARIO_AI_USE.DISABLED && !SCENARIO_AI_USE.PAID && !IS_IFRAMES}
                            />
                            <InputHint
                                top={-47}
                                buttonText='Upgrade'
                                onClick={handleUpgrade}
                                show={SCENARIO_AI_USE.DISABLED && IS_IFRAMES && profile?.AccountTier !== 'paid' && activeIframeSession}
                            />
                            <div className='scenario-chat-textarea-layout'>
                                {(isRecording || isVoiceUploading) ? (
                                    // 录音中或上传中显示声波可视化
                                    <VoiceWaveform
                                        audioData={audioData}
                                        onStop={handleStopRecording}
                                        barCount={35}
                                        isLoading={isVoiceUploading}
                                    />
                                ) : (
                                    <TextArea
                                        ref={textareaRef}
                                        value={inputValue}
                                        placeholder={placeholder}
                                        onKeyPress={handleKeyPress}
                                        onChange={handleInputChange}
                                        className="scenario-chat-textarea"
                                        disabled={(!IS_IFRAMES && !SCENARIO_AI_USE.PAID && SCENARIO_AI_USE.DISABLED) || (IS_IFRAMES && SCENARIO_AI_USE.PAID && profile?.AccountTier !== 'paid' && SCENARIO_AI_USE.DISABLED)}
                                        autoSize={{ minRows: 1, maxRows: 2 }}
                                    />
                                )}
                            </div>
                            {!isRecording && (
                                <div className='scenario-chat-tools'>
                                    <Mode />
                                    {!IS_IFRAMES && !SCENARIO_AI_USE.PAID && <RemainingCount count={SCENARIO_AI_USE.REMAINING} />}
                                    {IS_IFRAMES && profile?.AccountTier !== 'paid' && activeIframeSession && <RemainingCount count={SCENARIO_AI_USE.REMAINING} />}
                                </div>
                            )}
                            {!isRecording && !isVoiceUploading && (
                                <div
                                    className={`scenario-send-button ${isSendButtonActive ? 'active' : ''
                                        }`}
                                    onClick={() => handleClickSend()}
                                >
                                    <SendIcon active={isSendButtonActive} />
                                </div>
                            )}
                        </div>
                    </div>
                    <div className="ai-output-disclaimer">AI can make mistakes, validate responses</div>
                </div>
            )}

            {/* Share Modal */}
            <Modal
                title="Share Scenario AI with your team"
                styles={{ mask: { backgroundColor: 'rgba(0, 0, 0, 0.75)' } }}
                className='scenarioAI-share-modal'
                open={shareModalVisible}
                onCancel={() => setShareModalVisible(false)}
                footer={null}
                closeIcon={
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <path d="M16.2421 6.34407C16.6326 5.95355 17.2658 5.95355 17.6563 6.34407C18.0468 6.73459 18.0468 7.36776 17.6563 7.75828L7.75683 17.6578C7.36631 18.0483 6.73314 18.0483 6.34262 17.6578C5.95209 17.2673 5.95209 16.6341 6.34262 16.2436L16.2421 6.34407Z" fill="#6E6E70" />
                        <path d="M17.6562 16.2463C18.0467 16.6368 18.0467 17.27 17.6562 17.6605C17.2657 18.051 16.6325 18.051 16.242 17.6605L6.34247 7.76098C5.95194 7.37046 5.95194 6.73729 6.34247 6.34677C6.73299 5.95624 7.36616 5.95624 7.75668 6.34677L17.6562 16.2463Z" fill="#6E6E70" />
                    </svg>
                }
                width={566}
                centered
            >
                <div className='scenarioAI-share-modal-content'>
                    <span className='scenarioAI-share-modal-content-link'>https://www.zeitro.com/scenario-ai</span>
                    <div
                        className='scenarioAI-share-modal-content-copy-btn'
                        onClick={handleCopyLink}
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                            <g clip-path="url(#clip0_65_737)">
                                <rect width="20" height="20" transform="matrix(-1 0 0 -1 20 20)" fill="#FCFCFC" />
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M11.9157 5.58146H4.27022C2.94315 5.58146 1.86735 6.65726 1.86735 7.98433V15.6298C1.86735 16.9569 2.94315 18.0327 4.27022 18.0327H11.9157C13.2428 18.0327 14.3186 16.9569 14.3186 15.6298V7.98433C14.3186 6.65726 13.2428 5.58146 11.9157 5.58146ZM4.27022 3.61548C1.85737 3.61548 -0.0986328 5.57148 -0.0986328 7.98433V15.6298C-0.0986328 18.0427 1.85737 19.9987 4.27022 19.9987H11.9157C14.3286 19.9987 16.2846 18.0427 16.2846 15.6298V7.98433C16.2846 5.57148 14.3286 3.61548 11.9157 3.61548H4.27022Z" fill="#325CEB" />
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M19.0167 16.0671C19.5596 16.0671 19.9997 15.627 19.9997 15.0841V6.34644C19.9997 2.78748 17.1146 -0.0976238 13.5557 -0.0976238H4.81795C4.27506 -0.0976238 3.83496 0.342477 3.83496 0.885368C3.83496 1.42826 4.27506 1.86836 4.81795 1.86836H13.5557C16.0288 1.86836 18.0337 3.87326 18.0337 6.34644V15.0841C18.0337 15.627 18.4738 16.0671 19.0167 16.0671Z" fill="#325CEB" />
                            </g>
                            <defs>
                                <clipPath id="clip0_65_737">
                                    <rect width="20" height="20" fill="white" transform="matrix(-1 0 0 -1 20 20)" />
                                </clipPath>
                            </defs>
                        </svg>
                    </div>
                </div>
            </Modal>
        </div>
    )
}

export default WelcomeGuideline
